import * as React from "react";

import { getRoutePath, redirectToRoutePath, sectionClasses } from "../common/Utils";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";
import { WizardStep } from "../common/WizardStep";

import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";

import { LogStep } from "../../../Common/QuoteFormEventTracking/LogStep";

declare var minAgeInYears: number; // Global minimum age

interface IAdditionalDriverBirthdayStepState extends IStepState {
    birthdayError?: string;
}

export class AdditionalDriverBirthDayStep extends React.Component<IStepProps, IAdditionalDriverBirthdayStepState> {
    state: IAdditionalDriverBirthdayStepState;

    constructor(props: IStepProps) {
        super(props);

        this.handleOnClick = this.handleOnClick.bind(this);

        this.state = {
            birthdayError: "",
            redirectPath: "",
            goToNextStep: false
        }
    }

    handleOnClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        let valueElement = event.target as HTMLAnchorElement;
        let value = valueElement.dataset["value"];

        let birthMonth: number = parseInt(this.props.model.additionalDriver.birthMonth) - 1;
        let birthDay: number = parseInt(value);
        let birthYear: number = parseInt(this.props.model.additionalDriver.birthYear);

        let birthDate: Date = new Date(birthYear, birthMonth, birthDay);

        const today = new Date();
        const minDate = new Date(today.getFullYear() - minAgeInYears, today.getMonth(), today.getDate()); // JavaScript months start at 0, the form starts at 1

        if (minDate < birthDate) {
            this.setState({ birthdayError: "Please enter a valid year" });
            return;
        }

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.additionalDriver.birthDay = value;

        this.props.onUpdateModel(model);

        const routePath = getRoutePath(WizardStep.ADDITIONAL_DRIVER_NAME);

        this.setState({ redirectPath: routePath, goToNextStep: true });
    }

    getDaysInMonth(): number {
        switch (parseInt(this.props.model.additionalDriver.birthMonth)) {
            case 4:
            case 6:
            case 9:
            case 11:
                return 30;
            case 2:
                return this.leapYear(parseInt(this.props.model.additionalDriver.birthYear)) ? 29 : 28;
        }

        return 31;
    }

    leapYear(year: number): boolean {
        return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
    }

    getSelectedClass(optionValue: string): string {
        if (optionValue === this.props.model.additionalDriver.birthDay) {
            return "selected";
        }

        return "";
    }

    render(): JSX.Element {
        if (this.state.goToNextStep) {
            redirectToRoutePath(this.state.redirectPath);
            return null;
        }

        const sectionStyle = {
            display: 'block'
        }

        let days: Array<JSX.Element> = [];
        let daysInMonth: number = this.getDaysInMonth();

        for (var i = 1; i <= daysInMonth; i++) {
            var dayId = "additionalDriverBirthDay_" + i;
            days.push(<div key={dayId} className="touch-list-option"><a className={this.getSelectedClass(i.toString())} data-value={i} id={dayId} onClick={this.handleOnClick}>{i}</a></div>);
        }

        const error = this.state.birthdayError.length > 0 ? <span id="BirthdayValue_Error" className="field-invalid-text">{this.state.birthdayError}</span> : "";

        return <React.Fragment>
            <LogStep lastStep="AdditionalDriverBirthMonth" nextStep="AdditionalDriverName" stepNumber={QuoteFormEventType.AdditionalDriverBirthDayStep} sectionName="AdditionalDriverBirthDay" wizardName="AutoWizard" logStep={true} />
            <div id="AdditionalDriverBirthDayStep" className={sectionClasses} style={sectionStyle}>
                <h3>Birth Day</h3>
                {error}
                <div id="AdditionalDriverBirthDay">
                    <div className="touch-list fourColumn">
                        {days}
                    </div>
                </div>
            </div>
        </React.Fragment>;
    }
}